 <template>
  <van-popup
    position="bottom"
    v-model="show"
    :close-on-click-overlay="false"
    @click-overlay="cancel"
    :style="{ height: '40%', width: '100%' }"
  >
    <div class="popup">
      <div class="btn">
        <div @click="cancel" class="cancle">取消</div>
        <div @click="confirm" class="confirm">确定</div>
      </div>
      <van-checkbox-group v-model="result">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in columns"
            clickable
            :key="index"
            :title="item.name"
            @click="toggle(item, index)"
          >
            <template #right-icon>
              <van-checkbox :name="item.id" ref="checkboxes" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      result: [],
    };
  },
  methods: {
    confirm() {
      console.log(this.result);
      const resultItem = [];
      this.columns.forEach((item) => {
        if (this.result.indexOf(item.id) != -1) {
          resultItem.push(item);
        }
      });
      this.$emit("confirm", resultItem);
    },
    cancel() {
      this.$emit("cancel");
    },
    toggle(val, index) {
      let selectIndex = -1;
      const hasSelected = this.result.some((item, index) => {
        if (item == val.id) {
          selectIndex = index;
          return true;
        }
        return false;
      });
      if (hasSelected) {
        this.result.splice(selectIndex, 1);
      } else {
        this.result.push(val.id);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.popup {
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
  .btn {
    height: 60px;
    display: flex;
    justify-content: space-between;
    .cancle {
      padding: 15px 0px 15px 18px;
      font-size: 18px;
      font-weight: bold;
    }
    .confirm {
      padding: 15px 18px 15px 0px;
      font-size: 18px;
      font-weight: bold;
    }
  }
  /deep/ .van-checkbox-group {
    height: calc(100% - 60px);
    overflow: auto;
  }
}
.item {
  padding: 0 15px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f7f8f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.selected {
  width: 16px;
  height: 16px;

  background-size: 16px auto;
}
</style>


// WEBPACK FOOTER //
// src/cmscomponents/multiplePicker/multiplePicker.vue